import { useState, useRef } from "react";

import { Grid, Typography } from '@material-ui/core';
import { Assignment, Description, Person } from "@material-ui/icons";

import { GenericStepperForm } from "../../../atomic/organisms/GenericStepper";
import { SelectValidatorGeneric } from "../../../atomic/atoms/Select";
import { CustomDivider } from "../../../atomic/atoms/Divider";
import { capitalizarPrimerLetraCadaPalabra } from "../../../../helpers/strings";
import { isNumber, rangeLength, required } from "../../../../helpers/validations/validators";
import { GenericTable } from "../../../atomic/organisms/GenericTable";
import { ButtonGeneric } from "../../../atomic/atoms/Buttons";
import { ValidatorInputField } from "../../../atomic/atoms/Inputs";
import { useTotem } from "../../../../hooks/useCases/useTotem";
import { useFormNew } from "../../../../hooks/useFormNew";

const center = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}

export const CargaAfiliado = () => {
    const totem = useTotem();
  
    const { formValues, setFormValues } = useFormNew({
      idAfiliado: "",
      idParentesco: "",
      dni: "",
      idRecepcion: totem.data.opciones[0].recepcion.id,
      idOpcion: totem.data.opciones[0].id,
      IdSubOpcion: "",
    });
    
    const FirstStep = () => {
      const componentRef = useRef();
      const [inputValue, setInputValue] = useState("");
  
      return (
        <Grid container spacing={1} justify='center'>
          <Grid item xs={12} style={{...center, padding: "1em"}}>
            <Typography variant='h6'>Ingrese N° Documento o Carnet del Afiliado</Typography>
          </Grid>
          <CustomDivider />
          <Grid item xs={12} md={10} style={{margin: "1.5em"}}>
            <ValidatorInputField 
              label="DNI Afiliado | Carnet Afiliado"
              name="afiliado"
              variant="outlined"
              type="number"
              onChange={(e) => setInputValue(e.target.value)}
              value={inputValue}
              validations={[isNumber, rangeLength(7, 11)]}
              endAdornment={
                <ButtonGeneric 
                  text="BUSCAR"
                  disabled={inputValue.length < 7}
                  onClick={() => { 
                    totem.getByParameters.afiliado({ parameters: inputValue });
                    setInputValue("");
                  }}
                />
              }
            />
          </Grid>
          <Grid item xs={12} md={10} style={{border: "1px solid #ddd"}}>
            <GenericTable 
              ref={componentRef}
              data={totem.data.afiliados}
              sizeTableCells={["30%", "30%", "30%"]}
              withoutPagination
              align="center"
              tituloSinResultado="Sin datos de Afiliado"
              columns={[
                {
                  id: "nombre",
                  label: "Nombre Afiliado"
                },
                {
                  id: "dni",
                  label: "DNI"
                },
                {
                  id: "carnet",
                  label: "Carnet"
                }
              ]}
            />
          </Grid>
        </Grid>
      )
    };
  
    const SecondStep = () => {
      const componentRef = useRef();
  
      return (
        <Grid container spacing={1} justify='center'>
          <Grid item xs={12} style={{...center, padding: "1em"}}>
            <Typography variant='h6'>Turnos Afiliado {capitalizarPrimerLetraCadaPalabra(totem.data.afiliados[0].nombre)}</Typography>
          </Grid>
          <CustomDivider />
          <Grid item xs={12} md={10} style={{border: "1px solid #ddd", marginTop: "1.5em"}}>
            <GenericTable 
              ref={componentRef}
              data={totem.data.turnosAfiliados}
              withoutPagination
              align="center"
              tituloSinResultado="No posee turnos"
              columns={[
                {
                  id: "hora",
                  label: "Hora"
                },
                {
                  id: "nombreEfector",
                  label: "Médico"
                },
                {
                  id: "descripcionEspecialidad",
                  label: "Especialidad"
                },
                {
                  id: "piso",
                  label: "Piso"
                },
                {
                  id: "consultorio",
                  label: "Consultorio"
                },
              ]}
            />
          </Grid>
        </Grid>
      )
    };
  
    const ThirdStep = () => {
  
      const subOpciones = totem.data.opciones.find((item) => item.id === formValues.idOpcion)?.subOpciones;
      const recepcion = totem.data.recepciones.find((item) => item.id === formValues.idRecepcion);
  
      const dataSelects = [
        {
          value: formValues.idOpcion,
          list: totem.data.opciones,
          label: "Opción",
          name: "idOpcion",
          validations: [required],
          onChange: (value) => {
            const opcion = totem.data.opciones.find((item) => item.id === value);
  
            setFormValues({
              idOpcion: value,
              idRecepcion: opcion.recepcion.id,
              IdSubOpcion: opcion.subOpciones > 0 ? opcion.subOpciones[0].id : ""
            })
          }
        },
        {
          value: formValues.IdSubOpcion,
          list: subOpciones,
          label: "Sub Opción",
          name: "idSubOpcion",
          onChange: (value) => {
            const subOpcion = subOpciones.find((item) => item.id === value);
  
            setFormValues({
              IdSubOpcion: value,
              idRecepcion: subOpcion.recepcion.id
            })
          }
        } 
      ];
  
      return (
        <Grid container spacing={1} justify='center'>
          <Grid item xs={12} style={{...center, padding: "1em"}}>
            <Typography variant='h6'>Ingrese Solicitud para {capitalizarPrimerLetraCadaPalabra(totem.data.afiliados[0]?.nombre)}</Typography>
          </Grid>
          <CustomDivider />
          <Grid item xs={12} md={10} style={{marginTop: "1.5em"}}>
            <Grid container spacing={2} style={{ border: "1px solid #ddd"}}>
              <Grid item xs={12} style={{...center, padding: "1em"}}>
                <Typography variant='h6'>Recepción:  {!!recepcion ? recepcion.descripcion : "Sin Seleccionar"}</Typography>
              </Grid>
              <CustomDivider />
              {dataSelects.map(({value, list, onChange, label, name, validations = []}, index) => (
                <Grid key={index} item xs={12} md={6}>
                  <SelectValidatorGeneric 
                    variant="outlined"
                    label={label}
                    name={name}
                    value={value}
                    disabled={list.length === 0}
                    validations={validations}
                    onChange={(e) => { onChange(e.target.value) }}
                    menuItems={list.map((item) => ({
                      value: item.id,
                      label: item.descripcion
                    }))}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      )
    };
  
    return (
      <Grid item xs={12} md={8}>
        <GenericStepperForm
          title="Generar Solicitud Afiliado"
          steps={[
              {
                  stepLabel: "Seleccionar Afiliado",
                  Component: <FirstStep />,
                  disabledNext: totem.data.afiliados.length === 0,
                  handleClickNext: (handleNext) => {
                    const afiliado = totem.data.afiliados[0];
                    totem.getById.turnosAfiliados(afiliado.id);
                    handleNext();
                    setFormValues({
                      idAfiliado: afiliado.id,
                      idParentesco: afiliado.idParentesco,
                      dni: afiliado.dni,
                    })
                  }
              },
              {
                  stepLabel: "Turnos Afiliado",
                  Component: <SecondStep />,
              },
              {
                stepLabel: "Solicitud Afiliado",
                Component: <ThirdStep />,
              },
          ]}
          stepIcons={{
              1: <Person />,
              2: <Assignment />,
              3: <Description />,
          }}
          buttonLabelFinish="Confirmar"
          handleSubmit={(handleReset) => { 
            totem.insert.solicitudesAfiliadoRecepcionista(formValues, handleReset);
          }}
        />
      </Grid>
    )
}